<template>
  <button
    :class="['filter-button', { rounded, 'is-fish': true }]"
    data-test="all-filter-btn"
    @click="handleButtonClick"
  >
    <x-body-text weight="medium" data-test="all-filters-label">
      {{ label }}
    </x-body-text>
    <div class="filter-icon">
      <div v-if="hasFiltersActive" class="active-icon">
        <x-icon icon="filter" width="10px" height="10px" color="#fff" />
      </div>
      <x-icon v-else icon="filter" width="16px" height="16px" color="#333" />
    </div>
  </button>
</template>

<script setup lang="ts">
import xBodyText from '@/components/shared/x-body-text/index.vue'
import xIcon from '@/components/shared/x-icon/index.vue'

import { getActiveFiltersLength } from '@/services/filter-layer-service'
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import browser from '@/lib/browser'
import { setMobileMenuOpen } from '@/services/control-layout-service'

interface AllFilterButtonProps {
  label?: string
  rounded?: boolean
}
withDefaults(defineProps<AllFilterButtonProps>(), {
  label: 'All',
  rounded: false,
})

const router = useRouter()

const activeFiltersLength = computed(() => getActiveFiltersLength())
const hasFiltersActive = computed(() => !!activeFiltersLength.value)

const handleButtonClick = () => {
  if (browser.isMobile()) {
    setMobileMenuOpen(false)
  }
  const app = 'fish'
  router.push({ name: `${app}-mode` }).catch(() => {})
}
</script>

<style lang="scss" scoped>
@use '@/styles/system/_breakpoints.scss';
.filter-button {
  display: flex;
  align-items: center;
  gap: var(--ys-spacing-100);
  padding: var(--ys-spacing-100) var(--ys-spacing-200);
  border-radius: 10px;
  box-shadow:
    0px 1px 6px 0px rgba(0, 0, 0, 0.12),
    0px 2px 5px 0px rgba(0, 0, 0, 0.14);
  color: var(--ys-color-surface-reverse);
  background: var(--ys-color-text-reverse);

  @include breakpoints.app-prototyping() {
    display: flex;
  }

  @include breakpoints.mobile() {
    display: none;
    &.is-fish {
      display: flex;
    }
  }

  &.rounded {
    border-radius: 100px;
  }

  :deep(.x-icon) {
    line-height: 0;
  }
}

.filter-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
}

.active-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 21px;
  height: 21px;
  background-color: var(--ys-color-alert-success);
  border-radius: 100%;
}
</style>
